import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Leaderboard, { types } from './leaderboard';

export default class LargeLeaderboard extends PureComponent {
  static propTypes = {
    shortHeadline: PropTypes.string,
    agentName: PropTypes.string,
    suburb: PropTypes.string,
    buttonText: PropTypes.string,
    brandColor: PropTypes.string,
    primaryImageUrls: PropTypes.object,
    logoUrls: PropTypes.object
  };

  static defaultProps = {
    buttonText: 'Learn more'
  };

  render() {
    return <Leaderboard {...this.props} type={types.LARGE} />;
  }
}
